import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgStarFilled = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="m12.777 2.503 2.451 5.162a.8.8 0 0 0 .255.33.77.77 0 0 0 .378.153l5.412.836a.8.8 0 0 1 .426.193.87.87 0 0 1 .26.402.9.9 0 0 1 .014.484.9.9 0 0 1-.237.416l-3.901 4.037a.86.86 0 0 0-.218.353.9.9 0 0 0-.03.418l.942 5.677a.9.9 0 0 1-.05.484.9.9 0 0 1-.288.384.82.82 0 0 1-.896.065l-4.873-2.686a.88.88 0 0 0-.802 0l-4.873 2.686a.82.82 0 0 1-.896-.065.9.9 0 0 1-.288-.384.9.9 0 0 1-.05-.484l.94-5.74a.9.9 0 0 0-.028-.42.86.86 0 0 0-.218-.353L2.26 10.48a.9.9 0 0 1-.236-.427.9.9 0 0 1 .025-.493.87.87 0 0 1 .278-.399.8.8 0 0 1 .442-.176l5.413-.836a.77.77 0 0 0 .378-.154.8.8 0 0 0 .254-.329l2.452-5.162a.86.86 0 0 1 .307-.366.81.81 0 0 1 .897 0c.134.089.24.216.308.366"
      />
    </svg>
  );
};
export default SvgStarFilled;
